import { useState, useEffect } from "react";
import { useFilterStore } from "@/marketing/stores/useFilterStore";

export function MinFollowersFilter() {
  const minFollowers = useFilterStore((s) => s.filters.minFollowers);
  const setMinFollowers = useFilterStore((s) => s.setMinFollowers);
  const [input, setInput] = useState(
    minFollowers != null ? String(minFollowers) : "",
  );

  // Debounce: apply filter 500ms after user stops typing
  useEffect(() => {
    const timer = setTimeout(() => {
      const num = input === "" ? null : parseInt(input, 10);
      if (num !== null && isNaN(num)) return;
      if (num !== minFollowers) {
        setMinFollowers(num);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [input]);

  // Sync external resets (e.g. resetFilters)
  useEffect(() => {
    const expected = minFollowers != null ? String(minFollowers) : "";
    if (input !== expected && minFollowers === null) {
      setInput("");
    }
  }, [minFollowers]);

  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      placeholder="Min Followers"
      value={input}
      onChange={(e) => {
        const val = e.target.value.replace(/[^0-9]/g, "");
        setInput(val);
      }}
      className="tw-h-10 tw-w-[140px] tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-text-sm placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring"
    />
  );
}
